(() => {
  if (window.__mysliOfferInitialized) return;
  window.__mysliOfferInitialized = true;

  const getBundleButton = () => document.querySelector('[data-product-bundle] [data-bundle-add]');

  if ('IntersectionObserver' in window) {
    const marqueeObserver = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        entry.target.classList.toggle('is-visible', entry.isIntersecting);
      }
    });

    document.querySelectorAll('.mlo-marquee').forEach((marquee) => marqueeObserver.observe(marquee));
  }

  const focusBundle = () => {
    const bundle = document.querySelector('[data-product-bundle]');
    if (!bundle) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    bundle.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    window.setTimeout(() => getBundleButton()?.focus(), reduceMotion ? 0 : 450);
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const buyTrigger = event.target.closest('[data-mlo-buy]');
    if (buyTrigger) {
      event.preventDefault();
      focusBundle();
      return;
    }

    const stickyTrigger = event.target.closest('[data-mlo-sticky-buy]');
    if (stickyTrigger) {
      event.preventDefault();
      focusBundle();
      return;
    }

    const scrollTrigger = event.target.closest('[data-mlo-scroll]');
    if (!scrollTrigger) return;
    const root = scrollTrigger.closest('[data-mlo-carousel]');
    const scroller = root?.querySelector('[data-mlo-scroller]');
    if (!scroller) return;
    const direction = scrollTrigger.dataset.mloScroll === 'next' ? 1 : -1;
    scroller.scrollBy({ left: scroller.clientWidth * 0.82 * direction, behavior: 'smooth' });
  });
})();
